import { useParams, useNavigate } from "react-router";
import { FullPageLoading } from "../../UI/FullPageLoading.tsx";
import { AdminAllNormasTeachingCouponScreenPath } from "./AdminAllNormasTeachingCouponScreen.tsx";
import {
  useNormasTeachingCouponById,
  CouponType,
} from "../../ProductService/NormasTeachingCoupon/useNormasTeachingCouponById.ts";
import { useAllNormasTeachingCoupons } from "../../ProductService/NormasTeachingCoupon/useAllNormasTeachingCoupons.ts";
import { useUpdateNormasTeachingCoupon } from "../../ProductService/NormasTeachingCoupon/useUpdateNormasTeachingCoupon.ts";
import {
  CreateNormasTeachingCouponForm,
  CreateNormasTeachingCouponFormValues,
} from "./CreateNormasTeachingCouponForm.tsx";
import { useAllNormasTeachingBundles } from "../../ProductService/NormasTeachingBundle/useAllNormasTeachingBundles.ts";
import { useAllNormasTeachingProducts } from "../../ProductService/NormasTeachingProduct/useAllNormasTeachingProducts.ts";
import { mapValidityToPayload } from "../../UI/Utils/validityDays.ts";

export const EditNormasTeachingCouponScreenPath =
  "/admin/normasteaching/edit-coupon/:couponId";

export function EditNormasTeachingCouponScreen() {
  const { couponId } = useParams<{ couponId: string }>();

  const { coupon, isLoading: loadingCoupon } = useNormasTeachingCouponById(
    couponId!,
  );

  const { coupons, isLoading: isLoadingCoupons } =
    useAllNormasTeachingCoupons();
  const { products, isLoading: isLoadingProducts } =
    useAllNormasTeachingProducts();
  const { bundles, isLoading: isLoadingBundles } =
    useAllNormasTeachingBundles();

  const navigate = useNavigate();

  const { updateNormasTeachingCoupon, loading: updating } =
    useUpdateNormasTeachingCoupon();

  const onSubmit = async (data: CreateNormasTeachingCouponFormValues) => {
    if (!couponId) return;

    try {
      await updateNormasTeachingCoupon(couponId, {
        couponCode: data.couponCode,
        value: {
          amount:
            data.value.couponType === CouponType.Fixed
              ? data.value.amount * 100
              : data.value.amount,
          couponType: data.value.couponType,
        },
        maxNumberOfUses: data.maxNumberOfUses,
        ...mapValidityToPayload(data),
        applicableProducts: data.applicableProducts,
        isUnlimitedUses: data.isUnlimitedUses,
      });
      window.location.href = AdminAllNormasTeachingCouponScreenPath;
    } catch (error) {
      console.error("Errore durante l'aggiornamento del coupon:", error);
    }
  };

  const isLoading =
    loadingCoupon || isLoadingCoupons || isLoadingProducts || isLoadingBundles;

  if (isLoading) {
    return <FullPageLoading />;
  }

  const otherCoupons = coupons.filter((c) => c._id !== couponId);

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-6">
        <button
          onClick={() => navigate(AdminAllNormasTeachingCouponScreenPath)}
          className="text-blue-600 hover:text-blue-800 flex items-center gap-2"
        >
          ← Torna alla lista coupon
        </button>
      </div>

      <div className="bg-white rounded-lg shadow-md p-6">
        <h1 className="text-2xl font-bold mb-6">Modifica Coupon</h1>

        <CreateNormasTeachingCouponForm
          coupons={otherCoupons}
          creating={updating}
          onSubmit={onSubmit}
          initialCoupon={coupon}
          isEditMode={true}
          products={products}
          bundles={bundles}
        />
      </div>
    </div>
  );
}
